import React from 'react';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import listPlugin from '@fullcalendar/list';
import BootstrapTheme from '@fullcalendar/bootstrap';
import esLocale from '@fullcalendar/core/locales/es';
import PropTypes from 'prop-types';

const FullCalendarView = ({
  upcomingActivities,
  handleDateClick,
  handleActivityClick,
  onDrop,
  handleViewChange
}) => (
  <FullCalendar
    locale={esLocale}
    plugins={[
      BootstrapTheme,
      dayGridPlugin,
      interactionPlugin,
      listPlugin,
    ]}
    initialView="dayGridMonth"
    slotDuration={"00:15:00"}
    handleWindowResize={true}
    themeSystem="bootstrap"
    headerToolbar={{
      left: 'prev,next today',
      center: 'title',
      right: 'dayGridMonth,dayGridWeek,dayGridDay,listWeek',
    }}
    events={upcomingActivities}
    editable={true}
    droppable={true}
    selectable={true}
    dateClick={handleDateClick}
    eventClick={handleActivityClick}
    drop={onDrop}
    datesSet={handleViewChange}
    eventDidMount={(info) => {
      // Apply background and text color
      info.el.style.backgroundColor = info.event.backgroundColor;
      info.el.style.borderColor = info.event.borderColor;
      info.el.style.color = info.event.textColor;
    }}
  />
);

FullCalendarView.propTypes = {
  upcomingActivities: PropTypes.array.isRequired,
  handleDateClick: PropTypes.func.isRequired,
  handleActivityClick: PropTypes.func.isRequired,
  onDrop: PropTypes.func.isRequired,
  handleViewChange: PropTypes.func.isRequired,
};

export default FullCalendarView;
